<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1">
<p class="calibre26"> <span class="calibre5"> </span> </p>
<p class="calibre26"> <span class="calibre5"> </span> </p>
<p class="calibre26"> <span class="calibre5"> </span> </p>
<p class="calibre22"> <img alt="Table  Description automatically generated" class="calibre27" src="images/00003.jpeg"/> </p>
<p class="calibre22"> <img alt="Table  Description automatically generated" class="calibre28" src="images/00004.jpeg"/> </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0004.vue?7fdf4bc0